export default {
  name: 'CaseOwnerProfileModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['close', 'edit-profile'],
  computed: {
    metric_cards() {
      return Array.isArray(this.profile.metric_cards) ? this.profile.metric_cards : [];
    },
    contact_rows() {
      return Array.isArray(this.profile.contact_rows) ? this.profile.contact_rows : [];
    },
    specialties() {
      return Array.isArray(this.profile.specialties) ? this.profile.specialties : [];
    },
    case_snapshot() {
      return Array.isArray(this.profile.case_snapshot) ? this.profile.case_snapshot : [];
    }
  },
  methods: {
    close_modal() {
      this.$emit('close');
    },
    edit_profile() {
      this.$emit('edit-profile');
    }
  }
};
